import React, { useContext } from 'react';
import { Stack, Text } from 'library/ui';

import { BannedWorkerModalContext } from './BannedWorkerModalContext';
import { ShiftProviderUser } from 'models';

export default function Header() {
    const { provider }: { provider: ShiftProviderUser } = useContext(BannedWorkerModalContext);

    return (
        <Stack gap="sm">
            <Text size="sm" tone="secondary">
                You can block or unblock a worker for your whole center or just specific locations using the options
                below.{' '}
                <Text size="sm" weight="bold">
                    If they&apos;re booked for upcoming shifts, you will need to cancel those shifts individually.
                </Text>
            </Text>
            <Text weight="semibold">Choose locations to block {provider.first_name} from:</Text>
        </Stack>
    );
}
